
import { Constant } from "@/helpers/constant";
import { Component, Vue } from "vue-property-decorator";
import { TranslateMalay } from "@/languages/translate_malay";
import { TranslateEn } from "@/languages/translate_en";
import upSkillService from "@/services/upSkillService";

@Component({
  components: {
    //
  }
})

export default class Enrolments extends Vue {
  selectedLanguage: string = '';
  totalCountIntan:number=0;
  totalCountBomba:number=0;
  totalCounteLatih:number=0;

  handleClick(newTab) {
    //
  }

  created() {
    //
    
    if(localStorage.getItem("selectedlanguage") != undefined && localStorage.getItem("selectedlanguage") != null){
      this.selectedLanguage = localStorage.getItem("selectedlanguage");
    }else{
      localStorage.setItem("selectedlanguage", 'en');
      this.selectedLanguage = "en";
    }
    this.getTotalCollabPageCount();
  }

  convertToStandardNoFormat(count) {
    // let res = count.toString();
    // if (count.length == 4) {
    //   res = count.slice(0, 1) + "," + count.slice(1, count.length);
    // } else if (count.length == 5) {
    //   res = count.slice(0, 2) + "," + count.slice(2, count.length);
    // } else if (count.length == 6) {
    //   res =
    //     count.slice(0, -3) +
    //     "," +
    //     count.slice(-3);
    //   }
    // return res;
    if (typeof count !== "number" && typeof count !== "string") return count;
    const numStr = count.toString();
    return numStr.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  getTotalCollabPageCount() {
    let loader = this.$loading.show();
    let data = {
      provider: Constant.JOBSEEKER_PROVIDER,
    };


    upSkillService.getTotalEnrolmentsCountForCollabPage(data).then(
      (response) => {
        loader.hide();

        if (response != undefined) {

          console.log(response)
          if (response.data.statusCode == 200) {
            if (
              response.data != undefined &&
              response.data != null 
            )
            // debugger;
              if (response.data.totalCount != null) {

                // totalCountIntan:number=0;
                // totalCountBomba:number=0;
                // totalCounteLatih:number=0;
               this.totalCountIntan = this.convertToStandardNoFormat(
                  response.data.totalCount?.[0]?.totalIntan ?? 0
                );

                this.totalCountBomba = this.convertToStandardNoFormat(
                  response.data.totalCount?.[0]?.totalBomba ?? 0
                );

                this.totalCounteLatih = this.convertToStandardNoFormat(
                  response.data.totalCount?.[0]?.totalElatih ?? 0
                );
                
              } 
             
             else {
                //this.totalAvailableCourses = 0;
              }
          }
        }
      }
    );
  }
}
